<template>
  <div class="content stack stack--huge">
    <div class="flex flex--horizontal flex--align-center horizontal-stack horizontal-stack--huge">
      <FlexiHealthCheckCard
        key="flexi-health-check-card"
        :apiURL="flexi.url"
        @status-change="checkFlexi"
      />
      <FlexiTokenSetupCard
        v-if="(flexi.url && flexi.token && flexi.company && flexi.username)"
        key="flexi-token-setup-card"
        :apiURL="flexi.url"
        :token="flexi.token"
        :company="flexi.company"
        :username="flexi.username"
        @status-change="checkDocumentManagerToken"
      />
    </div>
    <ImportContainerCard
      v-if="documentManager.token"
      :token="documentManager.token"
      :roomID="documentManager.encodedRoomID"
      @container-change="updateDocumentManagerContainer"
    />
    <ImportCard
      v-if="(documentManager.token && documentManager.container)"
      :documentManagerToken="documentManager.token"
      :documentManagerContainer="documentManager.container"
      :flexiUrl="flexi.url"
      :flexiToken="flexi.token"
      :flexiCompany="flexi.company"
      @import="updateImportResults"
    />
    <ArchiveCard
      v-if="Object.keys(importResults).length > 0"
      :token="documentManager.token"
      :roomID="documentManager.encodedRoomID"
      :importResults="importResults"
    />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';

import FlexiHealthCheckCard from '@/components/FlexiHealthCheckCard';
import FlexiTokenSetupCard from '@/components/FlexiTokenSetupCard';
import ImportContainerCard from '@/components/ImportContainerCard';
import ImportCard from '@/components/ImportCard';
import ArchiveCard from '@/components/ArchiveCard';

import Flexi from '@/mixins/Flexi';
import DocumentManager from '@/mixins/DocumentManager';

import Buttons from '@/config/Buttons';

export default {
  name: 'Import',
  components: {
    FlexiHealthCheckCard,
    FlexiTokenSetupCard,
    ImportContainerCard,
    ImportCard,
    ArchiveCard,
  },
  mixins: [
    Flexi,
    DocumentManager,
  ],
  data() {
    return {
      status: null,
      documentManager: {
        token: null,
        container: null,
        encodedRoomID: null,
      },
      flexi: {
        status: null,
        url: null,
        token: null,
        username: null,
        company: '',
        buttons: Buttons,
      },
      importResults: {},
    };
  },
  methods: {
    checkFlexi(payload) {
      if (payload.status === 'flexi-available') {
        this.flexi.url = payload.data.url;
      } else {
        this.flexi.url = null;
      }
    },
    checkDocumentManagerToken(payload) {
      if (payload.status === 'token-exists' || payload.status === 'token-saved') {
        this.documentManager.token = payload.data.documentManagerToken;
      } else {
        this.documentManager.token = null;
      }
    },
    updateDocumentManagerContainer(payload) {
      this.documentManager.container = payload;
    },
    updateImportResults(payload) {
      this.importResults = payload;
    },
  },
  watch: {
    documentManager: {
      deep: true,
      handler() {
        const { token } = this.documentManager;
        if (token) {
          const decoded = jwtDecode(token);
          const [encodedRoomID] = decoded.sub.split(' ');
          this.documentManager.encodedRoomID = encodedRoomID;
        }
      },
    },
  },
  created() {
    const parsedUrl = new URL(this.$route.query.company);
    const company = parsedUrl.pathname.replace(/\/$/, '').split('/').pop();
    const url = `${parsedUrl.protocol}//${parsedUrl.host}`;
    this.flexi.url = url;
    this.flexi.username = this.$route.query.username;
    this.flexi.token = this.$route.query.token;
    this.flexi.company = company;
    this.flexi.evidence = this.$route.query.evidence;
  },
};
</script>
